import { render, staticRenderFns } from "./RecognitionS.vue?vue&type=template&id=3f2b8e53&scoped=true"
import script from "./RecognitionS.vue?vue&type=script&lang=js"
export * from "./RecognitionS.vue?vue&type=script&lang=js"
import style0 from "./RecognitionS.vue?vue&type=style&index=0&id=3f2b8e53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2b8e53",
  null
  
)

export default component.exports